import { ntxAPI } from '@API/axiosNeatex';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import React, { useEffect, useState } from 'react';
import { FaUpload, FaSave, FaCamera, FaSpinner } from 'react-icons/fa';
// import styles from './ItemImage.module.css'; // استيراد ملف الـ module
import styles from '../MasterItemsDetails/ItemImage.module.css'; // استيراد ملف الـ module
import { useAppDispatch, useAppSelector } from '@store/hooks';
import Loading from '@components/Shared/Loader/Loading';
import { cleanUpMasterItemsById, GetMasterItemsById } from '@store/INV/MasterItems/MasterItemsSlice';

const ItemImage = ({ ItemId }: { ItemId: string }) => {
  // const { loading: loading2, error } = useAppSelector(a => a.MasterItemsINV);
  const [imageURL, setImageURL] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  // const dispatch = useAppDispatch();

  const { MasterItemsById } = useAppSelector(a => a.MasterItemsINV);

  useEffect(() => {
    if (MasterItemsById) {
      setImageURL(MasterItemsById?.imagee?.filePath);
    }
  }, [MasterItemsById]);

  // Handle image upload
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const selectedFile = files[0];

      // Optional: Validate file type
      if (!selectedFile.type.startsWith('image/')) {
        alert('Please select a valid image file.');
        return;
      }

      setFile(selectedFile);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImageURL(reader.result as string);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  // Save image (simulated or via API)
  const handleSave = async (): Promise<void> => {
    if (!file) {
      alert('من فضلك اختر صورة أولاً.');
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('ITME_IMG', file); // استخدم اسم المعلمة ITME_IMG كما هو مطلوب

    try {
      const { data } = await ntxAPI.post(`Inv/UpdateItemImage?ItemId=${ItemId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (data.succeeded === true) {
        CustomAlert({ action: 'Add', msg: 'تم حفظ الصورة بنجاح!' });
      } else {
        CustomAlert({ action: 'Error', msg: 'فشل في حفظ الصورة' });
        throw new Error();
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('حدث خطأ أثناء رفع الصورة.');
    } finally {
      setLoading(false); // إيقاف مؤشر التحميل سواء نجح أو فشل
    }
  };

  return (
    <>
      <Loading loading={false}>
        <div className={styles.container}>
          {/* معاينة الصورة */}
          <div className={styles.imagePreview}>
            {imageURL ? (
              <img src={imageURL} alt='معاينة الصورة' />
            ) : (
              <div className={styles.noImage}>
                <FaCamera className={styles.noImageIcon} />
                <p>لا توجد صورة</p>
              </div>
            )}
          </div>

          {/* الأزرار */}
          <div className={styles.controls}>
            <label htmlFor='upload' className={styles.uploadLabel}>
              <FaUpload style={{ marginLeft: '8px' }} />
              اختر صورة
            </label>
            <input id='upload' type='file' accept='image/*' onChange={handleImageUpload} hidden />

            <button className={styles.btnSave} onClick={handleSave} disabled={loading}>
              {loading ? (
                <>
                  <FaSpinner className='fa-spin' style={{ marginLeft: '8px' }} />
                  جاري الحفظ...
                </>
              ) : (
                <>
                  <FaSave style={{ marginLeft: '8px' }} />
                  حفظ الصورة
                </>
              )}
            </button>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default ItemImage;
